import React, { Component } from 'react'
// import '@progress/kendo-theme-bootstrap/dist/all.css'
import { EDIDashboard } from './Components/Dashboard'

class EDIForms extends Component {
    render() {
        return <EDIDashboard />
    }
}

export default EDIForms
